import { render, staticRenderFns } from "./_purgeSBOLeague.vue?vue&type=template&id=697256bf&scoped=true&lang=pug&"
import script from "./_purgeSBOLeague.vue?vue&type=script&lang=js&"
export * from "./_purgeSBOLeague.vue?vue&type=script&lang=js&"
import style0 from "./_purgeSBOLeague.vue?vue&type=style&index=0&id=697256bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697256bf",
  null
  
)

export default component.exports